import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNavbarComponent } from '../navigation/top-navbar/top-navbar.component';
import { BottomNavbarComponent } from '../navigation/bottom-navbar/bottom-navbar.component';
import { SelectComponent as SelectTagComponent } from '../tags/select/select.component';

import { ManageComponent as ManageTagComponent } from '../tags/manage/manage.component';
import { TableModule } from 'primeng/table';
import { PickListModule } from 'primeng/picklist';
import { RouterModule } from '@angular/router';

import { NgxFilesizeModule } from 'ngx-filesize';
import { NgxFileDropModule } from 'ngx-file-drop';

import { ProgressBarModule } from 'primeng/progressbar';
import { SkeletonModule } from 'primeng/skeleton';
import { PipesModule } from '../../pipes/pipes.module'

import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { SearchItemComponent } from '../search/item/item.component';

import { SignaturesComponent } from '../signatures/signatures.component';
import { CreateComponent } from '../signatures/create/create.component';

import { UsersComponent } from '../users/users.component';
import { CreateComponent as UserCreateComponent } from '../users/create/create.component';



@NgModule({
  declarations: [
    TopNavbarComponent,
    BottomNavbarComponent,
    SelectTagComponent,
    ManageTagComponent,
    SearchItemComponent,
    SignaturesComponent,
    CreateComponent,
    UsersComponent,
    UserCreateComponent


  ],
  imports: [
    RouterModule,
    CommonModule,
    TableModule,
    PickListModule,
    ProgressBarModule,
    SkeletonModule,
    PipesModule,
    FormsModule,
    NgxFilesizeModule,
    NgxFileDropModule,
    MultiSelectModule
  ],
  exports: [
    TopNavbarComponent,
    BottomNavbarComponent,
    SelectTagComponent,
    ManageTagComponent,
    SearchItemComponent,
    SignaturesComponent,
    CreateComponent,
    UsersComponent,
    UserCreateComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class SharedModule { }
